import FragmentTrajectoryApp from './FragmentTrajectoryApp';
import { bootstrapReactApp } from '../shared';

bootstrapReactApp('iFragmentTrajectory', <FragmentTrajectoryApp />);
